import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import PasswordInput from "../../components/input/PasswordInput/PasswordInput";
import TextInput from "../../components/input/TextInput";
import { runLogin } from "../../utils/services";
import { StateContext } from "../../contexts/state.context";
import packageJson from "../../../package.json";
import styles from "./Login.module.scss";

const translateLoginCode = (code) => {
	switch (code) {
		case "LRG001":
			return "";
		case "LRG002":
			return "Falta el parametro password.";
		case "LRL003":
			return "Usuario o contraseña incorrectos.";
		case "LRL004":
			return "Usuario inactivo.";
		case "LRL005":
			return "Usuario desactivado.";
		case "LRL006":
			return "El usuario ya cuenta con una sesion activa.";
		case "LRL008":
			return "Su sesion ha expirado.";
		default:
			return "No se pudo iniciar sesion.";
	}
};

const Login = () => {
	const { setCurrentSession } = useContext(StateContext);
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const navigate = useNavigate();
	const appVersion = packageJson.version;

	const handleSubmit = async (event) => {
		event.preventDefault();
		setErrorMessage("");

		if (!username.trim() || !password.trim()) {
			setErrorMessage("Complete usuario y contraseña antes de ingresar.");
			return;
		}

		setIsLoading(true);

		try {
			const response = await runLogin({
				username,
				password,
			});

			if (response?.code === "LRG001") {
				setCurrentSession({ authenticated: true, username });
				navigate("/licence");
				return;
			}

			setErrorMessage(
				translateLoginCode(response?.code || response?.codigo || response),
			);
		} catch (error) {
			setErrorMessage(translateLoginCode(error?.code));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className={styles.loginPage}>
			<div className={styles.loginCard}>
					<form className={styles.formPanel} onSubmit={handleSubmit}>
					<h2 className={styles.title}>Iniciar sesión</h2>
					<TextInput
						id="username"
						name="username"
						label="Usuario"
						autoComplete="username"
						value={username}
						onChange={setUsername}
						className={styles.inputField}
						inputClassName={styles.input}
					/>
					<PasswordInput
						id="password"
						name="password"
						label="Contraseña"
						autoComplete="current-password"
						value={password}
						onChange={setPassword}
						className={styles.inputField}
						inputClassName={styles.input}
					/>
					<div className={styles.errorSlot}>
						<div
							className={`${styles.errorBox} ${
								errorMessage ? styles.errorBoxVisible : ""
							}`}
							role="alert"
							aria-live="polite"
						>
							{errorMessage}
						</div>
					</div>
					<button
						className={styles.button}
						type="submit"
						disabled={isLoading}
					>
						{isLoading ? "Ingresando..." : "Ingresar"}
					</button>
					<div className={styles.versionText}>Versión {appVersion}</div>
				</form>

				<div className={styles.imagePanel} aria-hidden="true">
					<div className={styles.imageToneOne} />
					<div className={styles.imageToneTwo} />
					<div className={styles.imageToneThree} />
				</div>
			</div>
		</div>
	);
};

export default Login;
